import { Box, DialogActions, Typography } from "@mui/material";
import ModalBasicLayout from "./ModalBasicLayout";
import ContainerModalActions from "../Containers/ContainerModalActions";
import { BUTTON_GO_BACK, TABLE_ADMIN_CANCELLATION_REASON_SUBTITLE } from "../../i18n/keysTranslations";
import { useTranslationApp } from "../../lib/i18next";

const CancellationReasonModal = ({
  modalOpen,
  onCloseModal,
  cancellationData,
  businessName
}) => {
  const { t } = useTranslationApp();
  if (!cancellationData) return null;

  return (
    <ModalBasicLayout
      modalOpen={modalOpen}
      onCloseModal={onCloseModal}
      title={t(TABLE_ADMIN_CANCELLATION_REASON_SUBTITLE)}
      description={businessName}
      maxWidth="md"
      fullWidth
      showCloseButton={true}
    >
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          gap: 1,
        }}
      >
        <Box sx={{ width: "100%" }}>
          {/* Razón detallada */}
          {cancellationData.reason && (
            <Box sx={{ mb: 3 }}>
              <Typography
                variant="body1"
                sx={{
                  p: 2,
                  backgroundColor: "#f9fafb",
                  borderRadius: 1,
                  border: "1px solid #e5e7eb",
                  minHeight: "80px",
                  whiteSpace: "pre-wrap",
                  wordBreak: "break-word",
                  overflowWrap: "break-word"
                }}
              >
                {cancellationData.reason}
              </Typography>
            </Box>
          )}
        </Box>
      </Box>

      <DialogActions
        sx={{
          p: 0,
        }}
      >
        <ContainerModalActions
          hasPadding={true}
          propsPrimaryButton={{
            showButton: true,
            text: BUTTON_GO_BACK,
            onClick: onCloseModal,
          }}
        />
      </DialogActions>
    </ModalBasicLayout>
  );
};

export default CancellationReasonModal;
